const Skills = () => {
    return (
        <section id="skills">
            <h2>Skills</h2>
            <ul className="skill-list">
                <li>AWS</li>
                <li>Docker</li>
                <li><a href="https://github.com/avinash-sharma-121/kubernetes_repo" target="_blank" style={{ textDecoration: 'none', color: 'inherit' }} rel="noreferrer">Kubernetes</a></li>
                <li><a href="https://github.com/avinash-sharma-121/react-testing-with-jenkins" target="_blank" style={{ textDecoration: 'none', color: 'inherit' }} rel="noreferrer">Jenkins</a></li>
                <li><a href="https://github.com/avinash-sharma-121/terraform_repo" target="_blank" style={{ textDecoration: 'none', color: 'inherit' }} rel="noreferrer">Terraform</a></li>
                <li><a href="https://github.com/avinash-sharma-121/ansible_repo" target="_blank" style={{ textDecoration: 'none', color: 'inherit' }} rel="noreferrer">Ansible</a></li>
                <li><a href="https://github.com/avinash-sharma-121/python_repo" target="_blank" style={{ textDecoration: 'none', color: 'inherit' }} rel="noreferrer">Python</a></li>
                <li>Linux</li>
                <li><a href="https://github.com/avinash-sharma-121/git_hands_on" target="_blank" style={{ textDecoration: 'none', color: 'inherit' }} rel="noreferrer">Git</a></li>
                <li>CI/CD</li>
                <li>Monitoring & Logging</li>
            </ul>
        </section>
    )
}

export default Skills;